// @ts-strict-ignore
import {Component, Input, OnInit, output} from "@angular/core";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import dayjs from "dayjs";
import {interval} from "rxjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/**
 * # Implementation Notes
 *
 * Because the relative `startDate` from which the timer starts counting is set
 * in `ngOnInit` the timer needs to be mounted right when it should start counting down,
 * otherwise the timer will be off.
 */
@UntilDestroy()
@Component({
	selector: "sim-countdown-timer",
	templateUrl: "./countdown-timer.component.html",
	styleUrls: ["./countdown-timer.component.scss"],
	standalone: false,
})
export class CountdownTimerComponent implements OnInit {
	@Input() seconds: number = 60;
	@Input() format: string = "ss";

	onTimeUp = output<void>();

	public remainingTime: string;

	private startDate: Date;

	constructor() {
		this.remainingTime = this.seconds.toString();
	}

	ngOnInit(): void {
		this.startDate = new Date();

		interval(1000)
			.pipe(untilDestroyed(this))
			.subscribe(() => {
				const remainingMilliseconds = this.getRemainingMilliseconds();
				if (remainingMilliseconds > 0) {
					this.remainingTime = dayjs(remainingMilliseconds).format(this.format);
				} else {
					this.onTimeUp.emit();
				}
			});
	}

	private getRemainingMilliseconds(): number {
		return dayjs
			.utc(this.startDate)
			.add(this.seconds + 1, "seconds")
			.diff(dayjs(), "milliseconds");
	}
}
